import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { focusAreas } from "@/data/focusAreas";

export default function FocusAreas() {
  const [leadArea, ...supportingAreas] = focusAreas;
  return (
    <section id="focus-areas" data-testid="ugi-current-focus-areas-section" className="bg-[#FDFBF7]">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="mb-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">Current Focus Areas</p>
            <h2 data-testid="focus-areas-heading" className="mt-5 font-serif text-3xl font-normal leading-tight tracking-[-0.02em] text-[#1C1613] sm:text-4xl">
              A starting point, not a limit.
            </h2>
          </div>
          <p className="max-w-xl text-base font-light leading-8 text-[#524842] lg:justify-self-end">
            UGI is open to sourcing across products and sectors based on international buyer requirements. These are the areas currently being focused on.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          <Link to={`/focus-areas/${leadArea.slug}`} data-testid={leadArea.testId || "focus-area-agro-food"} className="group relative min-h-[480px] overflow-hidden border border-[#C5A059]/20 bg-[#1C1613] text-[#FDFBF7] shadow-sm lg:col-span-2">
            <img src={leadArea.image} alt={leadArea.alt} loading="eager" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 ease-out group-hover:scale-[1.035]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C1613] via-[#1C1613]/25 to-transparent" />
            <div className="relative flex h-full flex-col justify-end p-8 sm:p-10">
              <span className="mb-5 w-max border border-[#C5A059]/50 bg-[#1C1613]/45 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#C5A059] backdrop-blur-sm">Lead Focus Area</span>
              <h3 className="max-w-xl font-serif text-3xl font-normal leading-tight sm:text-5xl">{leadArea.title}</h3>
              <p className="mt-5 max-w-xl text-sm leading-7 text-[#E6DED2] sm:text-base">{leadArea.items}</p>
            </div>
          </Link>

          {supportingAreas.map((area) => (
            <Link key={area.slug} to={`/focus-areas/${area.slug}`} data-testid={`focus-area-${area.slug === "electronics-electricals" ? "electronics" : area.slug.split("-")[0]}`} className="group overflow-hidden border border-[#E5DFD3] bg-[#F5F2EB] shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#C5A059]/35 hover:shadow-lg">
              <div className="aspect-[16/10] overflow-hidden bg-[#1C1613]">
                <img src={area.image} alt={area.alt} loading="eager" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.035]" />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between gap-4">
                  <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C5A059]">Current Focus</p>
                  <ArrowUpRight size={16} strokeWidth={1.5} className="text-[#9B7437]" />
                </div>
                <h3 className="mt-3 font-serif text-2xl font-normal leading-tight text-[#1C1613]">{area.title}</h3>
              </div>
            </Link>
          ))}
        </div>

        <p data-testid="focus-areas-non-exhaustive-note" className="mt-10 max-w-3xl border-l-2 border-[#C5A059] pl-5 text-sm leading-7 text-[#524842]">
          These groups are a current focus, not an exhaustive product catalogue. UGI reviews sourcing enquiries across products and sectors based on international buyer requirements.
        </p>
      </div>
    </section>
  );
}
